import { StateInterface } from "./state";

export default {
  setLoginBackground(state: StateInterface, payload: boolean | string): void {
    state.loginBackground = payload;
  },
  setBranded(state: StateInterface, payload: boolean): void {
    state.branded = payload;
  },
  setApplicationName(state: StateInterface, payload: string): void {
    state.applicationName = payload;
  },
};
